const catalogMenus = document.querySelectorAll('.almc-store-catalog-menu');
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const menuButton = document.querySelector('.almc-store-menu-toggle');
const navigation = document.getElementById('almc-store-nav');
if (menuButton && navigation) {
    const header = menuButton.closest('header');
    const mobile = window.matchMedia('(max-width: 850px)');
    const close = () => {
        menuButton.setAttribute('aria-expanded', 'false');
        navigation.removeAttribute('data-open');
        catalogMenus.forEach(menu => { menu.open = false; });
    };
    header.dataset.menuReady = 'true';
    menuButton.hidden = false;
    menuButton.addEventListener('click', () => {
        const expanded = menuButton.getAttribute('aria-expanded') === 'true';
        close();
        if (!expanded) {
            menuButton.setAttribute('aria-expanded', 'true');
            navigation.dataset.open = 'true';
        }
    });
    document.addEventListener('click', event => {
        if (!header.contains(event.target)) close();
        if (mobile.matches && event.target.closest('#almc-store-nav a')) close();
    });
    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
            close();
            menuButton.focus();
        }
    });
    document.addEventListener('focusin', event => { if (!header.contains(event.target)) close(); });
    mobile.addEventListener('change', close);
}

document.querySelectorAll('[data-almc-showcase]').forEach(showcase => {
    const track = showcase.querySelector('[data-showcase-track]');
    const slides = [...showcase.querySelectorAll('[data-showcase-slide]')];
    if (!track || slides.length < 2) return;
    const controls = showcase.querySelector('[data-showcase-controls]');
    const count = showcase.querySelector('[data-showcase-count]');
    const pause = showcase.querySelector('[data-showcase-pause]');
    let active = 0;
    let timer = null;
    let paused = motionPreference.matches || showcase.dataset.autoplay !== 'true';
    let hovering = false;
    const update = () => {
        slides.forEach((slide, index) => {
            slide.dataset.active = index === active ? 'true' : 'false';
            slide.inert = index !== active;
        });
        count.textContent = `${active + 1} / ${slides.length}`;
        count.setAttribute('aria-live', paused ? 'polite' : 'off');
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.querySelector('[data-showcase-pause-icon]').textContent = paused ? '▷' : 'Ⅱ';
    };
    const schedule = () => {
        window.clearTimeout(timer);
        if (!paused && !hovering && !document.hidden && !showcase.contains(document.activeElement)) {
            timer = window.setTimeout(() => { goTo(active + 1); schedule(); }, 6500);
        }
    };
    const goTo = index => {
        active = (index + slides.length) % slides.length;
        update();
        track.scrollTo({left: active * track.clientWidth, behavior: motionPreference.matches ? 'auto' : 'smooth'});
    };
    const stop = () => { paused = true; update(); schedule(); };
    controls.hidden = false;
    showcase.querySelector('[data-showcase-prev]').addEventListener('click', () => { stop(); goTo(active - 1); });
    showcase.querySelector('[data-showcase-next]').addEventListener('click', () => { stop(); goTo(active + 1); });
    pause.addEventListener('click', () => { paused = !paused; update(); schedule(); });
    showcase.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } });
    showcase.addEventListener('pointerleave', () => { hovering = false; schedule(); });
    track.addEventListener('pointerdown', stop, {passive: true});
    showcase.addEventListener('focusin', schedule);
    showcase.addEventListener('focusout', () => queueMicrotask(schedule));
    showcase.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const target = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1}[event.key];
        if (target === undefined) return;
        event.preventDefault(); stop(); goTo(target);
    });
    let scrollTimer = null;
    track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
            if (track.clientWidth) {
                active = Math.round(track.scrollLeft / track.clientWidth);
                update();
            }
        }, 120);
    }, {passive: true});
    document.addEventListener('visibilitychange', schedule);
    motionPreference.addEventListener('change', () => { if (motionPreference.matches) stop(); });
    if ('ResizeObserver' in window) {
        let width = track.clientWidth;
        new ResizeObserver(() => {
            if (width !== track.clientWidth) { width = track.clientWidth; track.scrollTo({left: active * width, behavior: 'instant'}); }
        }).observe(track);
    }
    update(); schedule();
});

// Reveal the first product rows together once; everything stays visible without JS.
if ('IntersectionObserver' in window && !motionPreference.matches) {
    const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('almc-store-arrived');
                reveal.unobserve(entry.target);
            }
        });
    }, {threshold: .08});
    document.querySelectorAll('.almc-store-grid').forEach(grid => reveal.observe(grid));
}

document.querySelectorAll('[data-almc-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-almc-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-almc-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-almc-gallery-thumb]')];
    const previous = gallery.querySelector('[data-almc-gallery-prev]');
    const next = gallery.querySelector('[data-almc-gallery-next]');
    const counter = gallery.querySelector('[data-almc-gallery-count]');
    if (!track || slides.length < 2) return;

    let active = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const select = (index) => {
        active = (index + slides.length) % slides.length;
        thumbs.forEach((thumb, i) => {
            if (i === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
        });
        counter.textContent = `${active + 1} / ${slides.length}`;
        // Keep the selected thumbnail visible without scrolling the whole page.
        const thumbnail = thumbs[active];
        const strip = thumbnail.parentElement;
        const left = thumbnail.offsetLeft;
        if (left < strip.scrollLeft || left + thumbnail.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({left: left - (strip.clientWidth - thumbnail.offsetWidth) / 2, behavior: 'auto'});
        }
    };
    const goTo = (index, smooth = true) => {
        select(index);
        track.scrollTo({left: active * track.clientWidth, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto'});
    };

    previous.hidden = next.hidden = counter.hidden = false;
    previous.addEventListener('click', () => goTo(active - 1));
    next.addEventListener('click', () => goTo(active + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        goTo(index);
    }));
    gallery.addEventListener('keydown', (event) => {
        const target = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1}[event.key];
        if (target === undefined || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        goTo(target);
    });
    let frame = null;
    track.addEventListener('scroll', () => {
        if (frame !== null) return;
        frame = requestAnimationFrame(() => {
            if (track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth));
            frame = null;
        });
    }, {passive: true});
    if ('ResizeObserver' in window) {
        let width = track.clientWidth;
        new ResizeObserver(() => {
            if (track.clientWidth !== width) {
                width = track.clientWidth;
                goTo(active, false);
            }
        }).observe(track);
    }
});

document.addEventListener('click', (event) => {
    catalogMenus.forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
    });
});
document.addEventListener('focusin', (event) => {
    catalogMenus.forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
    });
});
document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    catalogMenus.forEach((menu) => {
        if (menu.open) {
            menu.open = false;
            menu.querySelector('summary')?.focus();
        }
    });
});
document.querySelectorAll('[data-almc-map]').forEach((container) => {
    const button = container.querySelector('[data-almc-load-map]');
    if (!button) return;
    button.hidden = false;
    button.addEventListener('click', () => {
        const frame = document.createElement('iframe');
        frame.src = container.dataset.mapSrc;
        frame.title = container.dataset.mapTitle;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.allowFullscreen = true;
        container.replaceChildren(frame);
        frame.focus();
    }, {once: true});
});
